var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container no-results d-flex flex-column justify-content-center align-items-center w-100"},[_c('img',{staticClass:"no-results-img",attrs:{"src":require("../assets/logo_fill.svg")}}),_c('h2',{staticClass:"no-results-text my-5"},[_vm._v(_vm._s(_vm.$t('noResults')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }